import { createHttpHeaderWithAuthorization } from "../../services/http-header";
import { callWithRetry } from "../../services/callWithRetry";
import { API_PRECOG_URL_V1 } from "../../../config";

export const precogAccountedEntriesConstants = {
  GET_ACCOUNTEDENTRIES_DATA_START: "GET_ACCOUNTEDENTRIES_DATA_START",
  GET_ACCOUNTEDENTRIES_DATA_SUCCESS: "GET_ACCOUNTEDENTRIES_DATA_SUCCESS",
  GET_ACCOUNTEDENTRIES_DATA_ERROR: "GET_ACCOUNTEDENTRIES_DATA_ERROR",
  SAVE_FILTER: "SAVE_FILTER",

  GET_ACCOUNTEDENTRY_DATA_START: "GET_ACCOUNTEDENTRY_DATA_START",
  GET_ACCOUNTEDENTRY_DATA_SUCCESS: "GET_ACCOUNTEDENTRY_DATA_SUCCESS",
  GET_ACCOUNTEDENTRY_DATA_ERROR: "GET_ACCOUNTEDENTRY_DATA_ERROR"
};

export function getAccountedEntries(
  fromDate, toDate, dateFrom, dateTo, reasonIds, includeFilters
) {
  return (dispatch, getState) => {
    dispatch({
      type: precogAccountedEntriesConstants.SAVE_FILTER,
      payload: {
        fromDate: fromDate,
        toDate: toDate,
        fromDocDate: dateFrom,
        toDocDate: dateTo,
        reasonIds: reasonIds,
        includeSections: includeFilters
      }
    });

    const auth = getState().auth;
    const managerId = getState().main.accountantUuidSelected;
    const itemId = getState().main.companyUuidSelected;

    let url = `${API_PRECOG_URL_V1}/ledger/accountedEntries?itemId=${itemId}&managerId=${managerId}${fromDate ? `&fromDate=${fromDate}` : ""}${toDate ? `&toDate=${toDate}` : ""}${dateFrom ? `&fromDocDate=${dateFrom}` : ""}${dateTo ? `&toDocDate=${dateTo}` : ""}${reasonIds ? `&reasonIds=${reasonIds}` : ""}${includeFilters ? `&includeSections=${includeFilters}` : ""}`;

    return new Promise((resolve, reject) => {
      let request = {
        method: "GET",
        url: url,
        headers: {
          ...createHttpHeaderWithAuthorization(auth.loginAuth.securityToken)
        }
      };

      dispatch({
        type: precogAccountedEntriesConstants.GET_ACCOUNTEDENTRIES_DATA_START
      });

      callWithRetry(
        auth, request, dispatch
      ).then(async(result) => {
        if (result.status === 200 || result.status === 202) {
          dispatch({
            type: precogAccountedEntriesConstants.GET_ACCOUNTEDENTRIES_DATA_SUCCESS,
            payload: result
          });
          resolve(result);
        } else {
          dispatch({
            type: precogAccountedEntriesConstants.GET_ACCOUNTEDENTRIES_DATA_ERROR,
            error: result
          });
          reject();
        }
      })
        .catch((response) => {
          dispatch({
            type: precogAccountedEntriesConstants.GET_ACCOUNTEDENTRIES_DATA_ERROR,
            error: response
          });
          reject();
        });
    });
  };
}
